import { searchContent } from '@plone/volto/actions/search/search';

// Cada Document publicado nesta pasta vira uma coluna do rodapé, na ordem da
// pasta. O título do Document só identifica a coluna; não aparece no site.
export const RODAPE_PASTA = '/configuracao/footer';
export const RODAPE_SUBREQUEST = 'agsusRodape';

export const buscaRodape = () =>
  searchContent(
    // o caminho vai na URL (contexto do @search): via path.query na raiz, o
    // SSR interno não resolve
    RODAPE_PASTA,
    {
      portal_type: 'Document',
      review_state: 'published',
      'path.depth': 1,
      sort_on: 'getObjPositionInParent',
      fullobjects: true,
      b_size: 20,
    },
    RODAPE_SUBREQUEST,
  );

// Faz o servidor entregar a página já com as colunas, para o rodapé padrão
// não aparecer antes delas no navegador. Pasta ausente ou fora do ar não
// derruba a renderização: o rodapé cai no padrão.
export const rodapeAsyncPropExtender = {
  path: '/',
  extend: (dispatchActions) => {
    if (!dispatchActions.some((action) => action.key === RODAPE_SUBREQUEST)) {
      dispatchActions.push({
        key: RODAPE_SUBREQUEST,
        promise: ({ store: { dispatch } }) =>
          __SERVER__ && dispatch(buscaRodape()).catch(() => null),
      });
    }
    return dispatchActions;
  },
};
